import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText, PlayCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export default function Dashboard() {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Panou de Control</h1>
        <p className="text-muted-foreground mt-2">
          Bine ați venit! Selectați o opțiune pentru a continua.
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        <Card className="clinical-card group hover:shadow-lg hover:border-primary/30 transition-all duration-300 flex flex-col">
          <CardHeader className="flex-1">
            <div className="flex items-start gap-4">
              <div className="flex h-14 w-14 items-center justify-center rounded-lg bg-gradient-to-br from-primary/20 to-primary/10">
                <FileText className="h-7 w-7 text-primary" />
              </div>
              <div className="flex-1">
                <CardTitle className="text-xl">Evaluare Nouă</CardTitle>
                <CardDescription className="mt-2">
                  Începeți un screening de sănătate cuprinzător
                </CardDescription>
              </div>
            </div>
          </CardHeader>
          <CardContent>
            <Button
              className="w-full"
              size="lg"
              onClick={() => navigate('/flow-clinical')}
            >
              Începe Evaluarea
            </Button>
          </CardContent>
        </Card>

        <Card className="clinical-card group hover:shadow-lg hover:border-primary/30 transition-all duration-300 flex flex-col">
          <CardHeader className="flex-1">
            <div className="flex items-start gap-4">
              <div className="flex h-14 w-14 items-center justify-center rounded-lg bg-gradient-to-br from-secondary/20 to-secondary/10">
                <PlayCircle className="h-7 w-7 text-secondary" />
              </div>
              <div className="flex-1">
                <CardTitle className="text-xl">Simulări</CardTitle>
                <CardDescription className="mt-2">
                  Testați cu scenarii preconfigurate
                </CardDescription>
              </div>
            </div>
          </CardHeader>
          <CardContent>
            <Button
              className="w-full"
              size="lg"
              variant="outline"
              onClick={() => navigate('/scenarios')}
            >
              Vezi Scenarii
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

